import moment from 'moment';

export class FechaUtils {

  /** Convierte de DD/MM/YYYY → YYYY-MM-DD */
  static toIso(fecha: string): string | null {
    if (!fecha) return null;
    return moment(fecha, "DD/MM/YYYY", true).isValid()
      ? moment(fecha, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
  }

  /** Convierte de YYYY-MM-DD → DD/MM/YYYY */
  static toDisplay(fecha: string): string | null {
    if (!fecha) return null;
    return moment(fecha, "YYYY-MM-DD", true).isValid()
      ? moment(fecha, "YYYY-MM-DD").format("DD/MM/YYYY")
      : null;
  }
}
